export const columns = [
  {
    Header: 'Year',
    accessor: 'year',
  },
  {
    Header: 'Month',
    accessor: 'month'
  },
  {
    Header: 'User',
    accessor: 'user_id',
  },
  {
    Header: 'Vacations Days',
    accessor: 'days',
  },
];